$('.footer__secondary__newsletter input').on('click', function () {
  $(this).attr('placeholder', '');
}
).on('focusout', function () {
  $(this).attr('placeholder', 'E-mailadres');
});
